import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { browserHistory, Link } from 'react-router';

import { SITE_MODE, SITE_MODES } from 'config/site-mode';
import { Button } from 'components';

export default class SystemsDetail extends Component {

  /* Lifecycle */

  constructor(props) {
    super(props);

    this.closeHandler = this.closeHandler.bind(this);

    const { route, router } = this.props;
    router.setRouteLeaveHook(route, this.routerWillLeave.bind(this));
  }

  componentDidMount() {
    const { params, projectGet } = this.props;

    projectGet(params.projectId).catch(() => {
      browserHistory.push('/404');
    });
  }

  /* Handlers */

  routerWillLeave(nextLocation) {
    const { appModalOpen, modals } = this.props;

    if (nextLocation.pathname.indexOf('systems/') === -1) {
      if (modals.length > 0) {
        return true;
      }
      appModalOpen({
        component: <FormattedMessage id="systems.detail.leaveConfirmation" />,
        onCancel: () => {},
        onConfirm: () => { browserHistory.push(nextLocation.pathname); },
        title: <FormattedMessage id="systems.detail.leaveTitle" />,
        type: 'confirm',
      });

      return false;
    }
    return true;
  }

  closeHandler() {
    this.props.appModalOpen({
      component: <FormattedMessage id="systems.detail.leaveConfirmation" />,
      onCancel: () => {},
      onConfirm: this.goBackToOverview,
      title: <FormattedMessage id="systems.detail.leaveTitle" />,
      type: 'confirm',
    });
  }

  /* Methods */

  goBackToOverview() {
    browserHistory.push('/systems');
  }

  /* Render */

  render() {
    const { children } = this.props;

    return (
      <div className="view">
        <div className="view__header">
          {this.renderHeader()}
        </div>
        {children}
      </div>
    );
  }

  renderHeader() {
    return (
      <div className="header">
        <div className="container">
          <div className="row">
            <div className="gr-12">
              <div className="header__inner">
                <div className="align align--fluid align--gutter-md">
                  {this.renderTabs()}
                  {this.renderClose()}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderClose() {
    return (
      <div className="align__cell align__cell--shrink">
        <Button
          className="button"
          onClick={this.closeHandler}
        >
          <span className="icon icon-close icon--md" />
        </Button>
      </div>
    );
  }

  renderTabs() {
    const { params, location } = this.props;
    const breadcrumbs = [{
      id: 1,
      isPast: location.pathname.includes('quote') || location.pathname.includes('share'),
      link: `/systems/${params.projectId}/design`,
      title: 'systems.design.title',
    }, {
      id: 2,
      isPast: location.pathname.includes('share'),
      link: `/systems/${params.projectId}/quote`,
      title: 'systems.quote.title',
    }];

    if (SITE_MODE !== SITE_MODES.TU) {
      breadcrumbs.push({
        id: 3,
        isPast: false,
        link: `/systems/${params.projectId}/share`,
        title: 'systems.share.title',
      });
    }

    const content = breadcrumbs.map((tab) => {
      const tabClassNames = classNames('breadcrumbs__tab', { 'breadcrumbs__tab--is-faded': tab.isPast });

      return (
        <Link key={tab.id} to={tab.link} className={tabClassNames} activeClassName="is-active">
          <span className="breadcrumbs__number">{tab.id}</span>
          <span className="breadcrumbs__title"><FormattedMessage id={tab.title} /></span>
        </Link>
      );
    });

    return (
      <div className="align__cell u-text-center">
        <div className="breadcrumbs">
          {content}
        </div>
      </div>
    );
  }
}

SystemsDetail.propTypes = {
  appModalOpen: PropTypes.func,
  children: PropTypes.node,
  location: PropTypes.object,
  modals: PropTypes.array,
  params: PropTypes.object,
  projectGet: PropTypes.func,
  router: PropTypes.object,
  route: PropTypes.object,
};



// WEBPACK FOOTER //
// ./js/views/systems/detail/index.jsx